/*
  Kinaï : fiche produit pré-remplie depuis l'accueil (« Signez son style »).
  ?broderie=oui&fil=Bleu%20marine&prenom=KINAI
  Coche « Broderie : Oui », choisit la couleur du fil puis écrit le prénom dans les options Globo.
  (Le tissu, ?tissu=…, est géré par kinai-edit.js.)
*/
(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.has('kinai_edit')) return;
  var wantBrod = /^(oui|1|true)$/i.test(params.get('broderie') || '');
  var fil = params.get('fil');
  var prenom = (params.get('prenom') || '').trim().toUpperCase();
  if (!wantBrod && !fil && !prenom) return;

  function visible(el) { return !!(el && el.offsetParent !== null); }
  function inputs(test) {
    return Array.prototype.filter.call(document.querySelectorAll('.gpo-element input[data-field-name], .gpo-element textarea[data-field-name]'), test);
  }
  function fire(el, type) {
    var ev;
    try { ev = new Event(type, { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent(type, true, true); }
    el.dispatchEvent(ev);
  }
  function setValue(el, v) {
    var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
    setter.call(el, v);
    fire(el, 'input');
    fire(el, 'change');
    fire(el, 'blur');
  }

  var step = wantBrod || fil || prenom ? 'brod' : 'done';
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (step === 'brod') {
      var oui = inputs(function (i) { return /^broderie$/i.test(i.dataset.fieldName || '') && /^oui$/i.test(i.value) && !i.disabled && visible(i.closest('.gpo-element')); })[0];
      if (oui) {
        if (!oui.checked) oui.click();
        step = fil ? 'fil' : 'nom';
      } else if (tries > 30) {
        step = fil ? 'fil' : 'nom';
      }
    } else if (step === 'fil') {
      var c = inputs(function (i) { return /couleur de la broderie/i.test(i.dataset.fieldName || '') && i.value.toLowerCase() === fil.toLowerCase() && !i.disabled && visible(i.closest('.gpo-element')); })[0];
      if (c) {
        if (!c.checked) c.click();
        step = 'nom';
      } else if (tries > 50) {
        step = 'nom';
      }
    } else if (step === 'nom') {
      if (!prenom) { step = 'done'; }
      else {
        var n = inputs(function (i) { return /^(nom|pr[ée]nom)/i.test(i.dataset.fieldName || '') && (i.type === 'text' || i.tagName === 'TEXTAREA') && visible(i.closest('.gpo-element')); })[0];
        if (n) {
          var max = parseInt(n.getAttribute('maxlength'), 10);
          setValue(n, max > 0 ? prenom.slice(0, max) : prenom);
          step = 'done';
        }
      }
    }
    if (step === 'done' || tries > 70) clearInterval(t);
  }, 250);
})();
